import { Box, Grid, Typography, alpha, useTheme } from "@material-ui/core";

import Bold from "~/components/typography/bold";
import { Code } from "@material-ui/icons";
import GenericSvgIconWrapper from "~/icons/genericSvgIconWrapper";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ValidationResult } from "~/pages/singleChannel/amc/customAmcReport";

const ContentWrapper = styled(Grid)`
  background-color: ${({ theme }) =>
    theme.darkModeEnabled
      ? theme.palette.background.default
      : theme.palette.common.white};
  padding: 1rem;
  border-radius: 1rem;
  margin: 0.5rem 0;
  box-shadow: 0px 2px 6px 0px rgba(41, 35, 35, 0.05);
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) =>
      theme.darkModeEnabled
        ? alpha(theme.palette.background.default, 0.5)
        : alpha(theme.palette.common.white, 0.5)};
  }
`;

const AMLChatMessage = ({
  message,
  query,
  setCode,
  isValid,
  errorMessage,
  setValidationResult,
}: {
  message: string;
  query: string;
  setCode: (code: string) => void;
  setValidationResult: (result: ValidationResult) => void;
  isValid?: boolean;
  errorMessage?: string;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box width="80%" marginTop="0.5rem">
      <Typography variant="h6" color="textPrimary">
        {t("amc.chat.standardAMLResponse")}
      </Typography>
      <ContentWrapper
        container
        onClick={() => {
          setCode(query);
          setValidationResult({
            status: isValid ? "success" : "error",
            errorMessage: errorMessage || "",
          });
        }}
      >
        <Grid
          container
          alignItems="flex-start"
          justifyContent="flex-start"
          spacing={1}
        >
          <Grid item>
            <GenericSvgIconWrapper $color={theme.palette.text.primary}>
              <Code />
            </GenericSvgIconWrapper>
          </Grid>
          <Grid item>
            <Box pb={1}>
              <Bold variant="h5" color="textPrimary">
                {message}
              </Bold>
            </Box>
            <Typography variant="body2" color="textSecondary">
              {t("amc.chat.amlCodeTag")}
            </Typography>
          </Grid>
        </Grid>
      </ContentWrapper>
    </Box>
  );
};

export default AMLChatMessage;
